module.exports = __webpack_public_path__ + "img/UDVN-1.4bc2b38f.png";